import {connect} from 'react-redux';
import AuditBowlerDetailList from './AuditBowlerDetailList.jsx'; 
import {
} from './actions';
import {
  } from './actionTypes';

const mapStateToProps = state => ({ 
  headerBowler: state.admin.bowlerAudit.headerBowler,
  list: state.admin.bowlerAudit.auditDetails
});

const mapDispatchToProps = () => ({ 
});

export default connect(mapStateToProps, mapDispatchToProps)(AuditBowlerDetailList);



// WEBPACK FOOTER //
// ./src/features/admin/audit/bowlerAudit/AuditBowlerDetailListContainer.jsx